import React from 'react';
import { Link } from 'react-router-dom';
import { Award, ArrowLeft, Building2, Calendar, Euro, Target, TrendingUp } from 'lucide-react';
import ueHeader from '../assets/ue_header.png';
import ueFooter from '../assets/ue_fotter.png';
import './LegalPages.css';

const FonduriEuropene = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          <span>Înapoi la Pagina Principală</span>
        </Link>

       

       

        <div className="legal-content">
          {/* Anunț Finalizare */}
          
 {/* UE Header Image */}
        <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
          <img
            src={ueHeader}
            alt="Uniunea Europeană - Fonduri Europene"
            style={{
              maxWidth: '100%',
              height: 'auto',
            
            }}
          />
        </div>
          <section className="legal-section">
            <h2>
        
              DEZVOLTAREA FIRMEI PRIN DIGITALIZARE
            </h2>

            <div className="company-info">
              <h3>Beneficiar:</h3>
              <p><strong>MULTIPOWER TOUR S.R.L.</strong></p>
              <ul>
                <li><strong>Cod de identificare fiscală:</strong> 20571818</li>
                <li><strong>Nr. Registrul Comerțului:</strong> J07/20/2007</li>
                <li><strong>Adresă sediu:</strong> Str. Zefirului, nr. 19, localitatea Dorohoi, județul Botoșani, România, cod poștal 715200</li>
              </ul>
            </div>

            <div className="info-box">
              <p>
                <strong>Program operațional:</strong> PRNE - Program Regional Nord-Est
              </p>
              <p style={{ marginTop: '0.5rem' }}>
                <strong>Axa:</strong> PRNE_P2 P2.P2. Nord-Est – O regiune mai digitalizată
              </p>
              <p style={{ marginTop: '0.5rem' }}>
                <strong>Prioritate:</strong> PRNE_P2 O regiune mai digitalizată
              </p>
              <p style={{ marginTop: '0.5rem' }}>
                <strong>Apel:</strong> Transformarea digitală a IMM-urilor orientată către creșterea intensității digitale,
                PR/NE/2023/PI2/RSO1.2/1 – DIGITALIZARE IMM
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>Perioada de implementare:</strong> 12 luni, de la data semnării Contractului de Finanțare,
                respectiv de la <strong>05.11.2024 până la 05.11.2025</strong>.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>
        
              Detalii Contract
            </h2>

            <div className="legal-table-wrapper">
              <table className="legal-table">
                <tbody>
                  <tr>
                    <td><strong>Contract de finanțare</strong></td>
                    <td>Nr. 577 din 05.11.2024</td>
                  </tr>
                  <tr>
                    <td><strong>Cod proiect SMIS</strong></td>
                    <td>320634</td>
                  </tr>
                  <tr>
                    <td><strong>Durata proiectului</strong></td>
                    <td>12 luni</td>
                  </tr>
                  <tr>
                    <td><strong>Data de începere</strong></td>
                    <td>05.11.2024</td>
                  </tr>
                  <tr>
                    <td><strong>Data finalizare</strong></td>
                    <td>05.11.2025</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="legal-section">
            <h2>
           
              Obiectivele Proiectului
            </h2>

            <h3>Obiectiv General</h3>
            <p>
              Creșterea competitivității firmei la nivel regional prin <strong>creșterea gradului de digitalizare a firmei</strong>.
            </p>

            <h3>Obiective Specifice</h3>
            <ul>
              <li>
                <strong>Creșterea intensității digitale a firmei în următorul an prin implementarea de soluții tehnice astfel încât să fie atinse 9 criterii DESI;</strong>
              </li>
              <li>
                <strong>Creșterea cu minim 10% a cifrei de afaceri în următorul an prin implementarea soluțiilor tehnologice noi;</strong>
              </li>
              <li>
                <strong>Creșterea vizibilității firmei și promovarea brandului firmei la nivel local prin interacțiuni social-media.</strong>
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>
 
              Valoarea Proiectului
            </h2>

            <div className="legal-table-wrapper">
              <table className="legal-table">
                <thead>
                  <tr>
                    <th>Categoria</th>
                    <th>Valoare (LEI)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Valoare totală a proiectului</strong></td>
                    <td><strong>644.844,06</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Asistență nerambursabilă TOTAL</strong></td>
                    <td><strong>492.726,60</strong></td>
                  </tr>
                  <tr>
                    <td>Din care: Fonduri FEDR</td>
                    <td>418.817,61</td>
                  </tr>
                  <tr>
                    <td>Din care: Buget de Stat (BS)</td>
                    <td>73.908,99</td>
                  </tr>
                  <tr>
                    <td>Valoare cofinanțare beneficiar</td>
                    <td>54.747,40</td>
                  </tr>
                  <tr>
                    <td>Valoare neeligibilă</td>
                    <td>97.370,06</td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </section>

          <section className="legal-section">
            <h2>
            
              Rezultatele Proiectului
            </h2>

            <div className="gdpr-principles">
              <div className="principle-card">
                <h3>Campanie de Promovare</h3>
                <p>
                  O campanie de promovare plătită pe rețelele de socializare pentru creșterea vizibilității
                  și a gradului de interacțiune cu clienții.
                </p>
              </div>

              <div className="principle-card">
                <h3>Tehnologii Digitale</h3>
                <p>
                  Implementarea a minimum <strong>10 tehnologii de digitalizare</strong> pentru modernizarea
                  proceselor de business și serviciilor oferite.
                </p>
              </div>

              <div className="principle-card">
                <h3>Echipamente și Software</h3>
                <p>
                  Achiziția a <strong>105 echipamente</strong> și <strong>3 active necorporale/software</strong>
                  pentru susținerea transformării digitale.
                </p>
              </div>
            </div>
          </section>

          <section className="legal-section">
            <h2>
          
              Impactul Investiției
            </h2>

            <div className="info-box">
              <h3>Impact la nivelul localităţii / regiunii:</h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                <strong>Digitalizarea serviciilor de transport</strong> și <strong>creșterea gradului de accesibilitate</strong>
                a acestor servicii cu ajutorul tehnologiilor digitale. Această investiție contribuie la modernizarea
                infrastructurii de transport public din regiunea Nord-Est, îmbunătățind experiența călătorilor și
                eficiența operațională a companiei.
              </p>
            </div>
          </section>

          <section className="legal-section">
            

            <div className="info-box">
              <h3>Detalii suplimentare:</h3>
              <p>
                <strong>Regio Nord Est - Aproape de tine</strong>
              </p>
              <ul>
                
                  Website: <a href="https://www.regionordest.ro" target="_blank" rel="noopener noreferrer">
                    www.regionordest.ro
                  </a>
            
              
                  Facebook: <a href="https://facebook.com/Regio.NordEst.ro" target="_blank" rel="noopener noreferrer">
                    facebook.com/Regio.NordEst.ro
                  </a>
             
              </ul>

              <p style={{ marginTop: '1.5rem' }}>
                <strong>Programe cofinanțate de Uniunea Europeană:</strong>
              </p>
              <ul>
               
                  Ministerul Fondurilor Europene: <a href="https://mfe.gov.ro" target="_blank" rel="noopener noreferrer">
                    https://mfe.gov.ro
                  </a>
                
              </ul>
            </div>
          </section>

    
        </div>

        {/* UE Footer Image */}
        <div style={{ marginTop: '2rem', marginBottom: '2rem', textAlign: 'center' }}>
          <img
            src={ueFooter}
            alt="Uniunea Europeană - Programul Regional Nord-Est"
            style={{
              maxWidth: '100%',
              height: 'auto',
            
            }}
          />
        </div>

        <div className="legal-navigation">
          <Link to="/termeni" className="legal-nav-link">
            Termeni și Condiții →
          </Link>
          <Link to="/confidentialitate" className="legal-nav-link">
            Politica de Confidențialitate →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FonduriEuropene;
